<template>
  <div class="_content">
      <div style="width: 100%;text-align: center;margin-top: 1rem">
          <van-icon name="passed" color="#1677FF" size="70" />
          <p style="color: #1677FF;font-size: 1rem;margin-top: 10px">客户{{ orderStatus }}</p>
      </div>
      <div class="det-info">
          <p>
              <span>合计收款</span>
              <span style="color: #FF3B30">￥ {{ billData.totalPayPrice }}</span>
          </p>
          <p>
              <span>商品订单</span>
              <span>{{ billData.orderId }}</span>
          </p>
          <p>
              <span>下单时间</span>
              <span>{{ billData.placeTheOrderOfTime }}</span>
          </p>
      </div>
      <div class="ser-info">
              <div class="title">
                  <div class="tit-con">
                    <span>服务</span>
                    <span>金额</span>
                    <span>数量</span>
                  </div>
              </div>
              <div class="ser-main">
                  <div v-for="(item, index) in billData.childGoodsDetaiDtos" :key="index">
                    <span>{{ item.goodsName }}</span>
                    <span>￥{{ item.goodsPrice }}</span>
                    <span>{{ item.buyCount }}</span>
                  </div>
              </div>
      </div>
      <div style="text-align: center;margin-top: 30px">
          <van-button round style="width: 8rem;margin: 0px;padding: 0px;" size="normal" type="info" @click="newBack">重新下新单</van-button>
          <p style="font-size:15px;color: #BEBEBE;margin-top: 10px">咨询客服 <i style="color: #006EEF" v-call>400-176-8848</i></p>
      </div>
  </div>
</template>

<script>
import config from '@/configs/config'
// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
export default {
  data() {
    return {
        billData: {},
        orderStatus: ''
        }
    },
    created() {
        this.billDetail()
    },
    mounted() {
        // let vConsole = new VConsole()
    },
  methods: {
      billDetail() {
          let orderId = tuhu.getParam('orderId')
          console.log(orderId)
           tuhu.fetch(`${config.apis.GOODS_DETAIL}/${orderId}`)
           .then((data) => {
                    if (data && data.code === '200') {
                       this.billData = data.data
                       if (data.data.orderStatus === 'ORDER_INIT') {
                           this.orderStatus = '待接单'
                       } else if (data.data.orderStatus === 'ORDER_ACCEPT') {
                            this.orderStatus = '已接单'
                       } else if (data.data.orderStatus === 'ORDER_CANCEL') {
                            this.orderStatus = '订单取消'
                       } else if (data.data.orderStatus === 'ORDER_FINISH') {
                            this.orderStatus = '订单完成'
                       } else if (data.data.orderStatus === 'ORDER_CLOSED') {
                            this.orderStatus = '订单关闭'
                       } else if (data.data.orderStatus === 'ORDER_DISPATCH') {
                            this.orderStatus = '已派单'
                       }
                    } else {
                    tuhu.toast(data.message || '网络错误')
                    }
                }).catch(
                    error => console.error('Error:', error)
                )
      },
      newBack() {
          let newBackUrl = JSON.parse(tuhu.sessionStorage.getItem('newBackUrl'))
          console.log(newBackUrl)
          tuhu.navigateTo(
          {
            url: newBackUrl
          }
        )
      }
  }
      
}
</script>
<style lang="less" scoped>
.det-info{
    width: 96%;
    background-color: #fff;
    margin-left: 2%;
    border-radius: 5px;
    margin-top: 0.8rem;
    p{
        width: 92%;
        margin-left: 4%;
        font-size: 0.9rem;
        color: #666;
        line-height: 2rem;
        span:last-child{
            float: right;
        }
    }
}
.ser-info{
    width: 96%;
    background-color: #fff;
    margin-left: 2%;
    border-radius: 5px;
    margin-top: 0.7rem;
        .title{
            background-color: #FFFBE3;
            padding: 10px 0px;
            .tit-con{
                width: 92%;
                margin-left: 4%;
                display: flex;
            span{
                display: block;
                width: 33.3333%;
                font-size: 0.8rem;
                color: #181518;
            }
            span:nth-child(2) {
                text-align: center;
            }
            span:last-child{
                    text-align: right;
                }
            }
        }
        .ser-main{
            width: 92%;
            margin-left: 4%;
            div{
                display: flex;
                padding: 16px 0px;
                span{
                    display: block;
                    width: 33.3333%;
                    font-size: 0.8rem;
                    color: #666;
                }
                span:nth-child(2) {
                    text-align: center;
                }
                span:last-child{
                    text-align: right;
                }
            }
        }
}
</style>


// WEBPACK FOOTER //
// src/pages/cashiers/billDetail.vue